/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SiteResultConfigBackfillResultDto } from '../models/SiteResultConfigBackfillResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SiteResultConfigBackfillService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param pageNumber
     * @param pageSize
     * @param force
     * @returns SiteResultConfigBackfillResultDto OK
     * @throws ApiError
     */
    public postApiHousingSiteResultConfigBackfillPreviewBackfill(
        pageNumber: number = 1,
        pageSize: number = 100,
        force: boolean = false,
    ): CancelablePromise<SiteResultConfigBackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SiteResultConfigBackfill/PreviewBackfill',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'force': force,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param pageNumber
     * @param pageSize
     * @param force
     * @returns SiteResultConfigBackfillResultDto OK
     * @throws ApiError
     */
    public postApiHousingSiteResultConfigBackfillExecuteBackfill(
        pageNumber: number = 1,
        pageSize: number = 100,
        force: boolean = false,
    ): CancelablePromise<SiteResultConfigBackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/SiteResultConfigBackfill/ExecuteBackfill',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'force': force,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
